export type TcIconName = "bullet" | "blitz" | "rapid" | "classical" | "endless";

export interface TimeControlOption {
  id: "bullet" | "blitz" | "rapid" | "classical" | "none";
  label: string;
  detail: string;
  icon: TcIconName;
}

export const TIME_CONTROLS: readonly TimeControlOption[] = [
  { id: "bullet", label: "Bullet", detail: "1+0 · 2+1", icon: "bullet" },
  { id: "blitz", label: "Blitz", detail: "3+2 · 5+0", icon: "blitz" },
  { id: "rapid", label: "Rapid", detail: "10+0 · 15+10", icon: "rapid" },
  { id: "classical", label: "Classical", detail: "30+30", icon: "classical" },
  { id: "none", label: "No limit", detail: "Endless", icon: "endless" },
];

// Display label ↔ backend Situation slug. Only the reliably-detectable motifs
// are exposed (the shaky ones — stalemate trap, perpetual check, time scramble,
// pawn breaks, bad-bishop trade, overloaded/removing-defender — are hidden in
// v1; see the implementation plan).
export const SITUATIONS: ReadonlyArray<{ slug: string; label: string }> = [
  { slug: "fork", label: "Forks" },
  { slug: "pin", label: "Pins" },
  { slug: "skewer", label: "Skewers" },
  { slug: "discovered_attack", label: "Discovered attacks" },
  { slug: "double_attack", label: "Double attacks" },
  { slug: "back_rank", label: "Back-rank weakness" },
  { slug: "hanging_piece", label: "Hanging pieces" },
  { slug: "mate_in_2", label: "Mate in 2" },
  { slug: "mate_in_3", label: "Mate in 3" },
  { slug: "kp_endgame", label: "King + pawn endgames" },
  { slug: "rook_endgame", label: "Rook endgames" },
  { slug: "opposite_bishops", label: "Opposite-color bishops" },
  { slug: "outpost", label: "Outposts" },
];

export const SITUATION_LABEL: Record<string, string> = Object.fromEntries(
  SITUATIONS.map((s) => [s.slug, s.label]),
);

// Legacy display-only list still used by the one-off situation picker.
export const ALL_SITUATIONS = SITUATIONS.map((s) => s.label);

export const GAME_PHASES: ReadonlyArray<{ slug: string; label: string }> = [
  { slug: "opening", label: "Opening" },
  { slug: "middlegame", label: "Middle game" },
  { slug: "endgame", label: "Late game" },
];

export const ALL_OPENINGS = [
  "Italian Game", "Ruy López", "Scotch", "Queen's Gambit", "King's Gambit",
  "Sicilian · Najdorf", "Sicilian · Dragon", "Caro-Kann", "French Defense",
  "King's Indian Defense", "Queen's Indian", "English Opening", "Nimzo-Indian",
  "Catalan", "London System", "Réti", "Vienna Game", "Pirc Defense",
];
